<div class="container">
    <div class="search-box">
        <div class="search-input left">
            <app-search [id] = "1"  [limit] = "1" (item)="callitem($event)"  (searchstr)="searchstr($event)"></app-search>
        </div>
        <div>
            <button class="cool-button" (click)="checkUserStatus()">確認關係</button>
        </div>
        <div class="search-input right">
            <app-search [id] = "2" [limit] = "1"  (item)="callitem1($event)"  (searchstr)="searchstr1($event)"></app-search>
        </div>
    </div>
    <div class="relationshipDiv">
        <div class="relationship-status1" style="display: flex;">
            <img loading="lazy" *ngIf="target.uid != ''"  class="rounded-image" [src]="target.profile_pic" alt="{{target.name}}">
            <p *ngIf="target.uid != ''" >已選擇:{{target.uid}}</p>
        </div>
        <div class="relationship-status1" style="display: flex;">
            <img loading="lazy" *ngIf="target1.uid != ''" class="rounded-image" [src]="target1.profile_pic" alt="{{target1.name}}">
            <p *ngIf="target1.uid != ''">已選擇:{{target1.uid}}</p>
        </div>
    </div>
    <div class="relationshipDiv">
        <div class="relationship-status">
            <p class="user-status" style="margin-right: 50px;background-color: #b1a93e;" *ngIf="status == -1">此用戶已停權</p>
            <p class="user-status" style="margin-right: 50px;background-color: #eb482b;"  *ngIf="status == -2">此用戶已刪帳號</p>
        </div>
        <div class="relationship-status">
            <p class="user-status" style="margin-left: 50px;background-color: #b1a93e;" *ngIf="status1 == -1">此用戶已停權</p>
            <p class="user-status" style="margin-left: 50px;background-color: #eb482b;"  *ngIf="status1 == -2">此用戶已刪帳號</p>
        </div>
    </div>
    <div class="relationshipDiv">
        <p class="user-relationStatus blink-effect"  [style.background-color]="color" *ngIf="this.relationship != ''">{{relationship}}</p>
    </div>
</div>